module.exports = __webpack_public_path__ + "img/logo.a5521e18.png";